// extracted by mini-css-extract-plugin
export default {"dropdown_li":"option-set-dropdown-item_dropdown_li__9ne0M","item_text":"option-set-dropdown-item_item_text__Ik4A7"};